/**
 * @generated SignedSource<<de581cf689b49e0b579a531382ae8b18>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutProcessingPage_item$data = {
  readonly isMultiSku: boolean;
  readonly mediumPhoto: string | null;
  readonly title: string | null;
  readonly " $fragmentType": "CheckoutProcessingPage_item";
};
export type CheckoutProcessingPage_item$key = {
  readonly " $data"?: CheckoutProcessingPage_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutProcessingPage_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutProcessingPage_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isMultiSku",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": "mediumPhoto",
      "args": [
        {
          "kind": "Literal",
          "name": "size",
          "value": "medium"
        }
      ],
      "kind": "ScalarField",
      "name": "firstPhotoWebPath",
      "storageKey": "firstPhotoWebPath(size:\"medium\")"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "ecfc518c6fc79d30ec1cb220c6431a56";

export default node;
